import { render, staticRenderFns } from "./follow-history-query.vue?vue&type=template&id=58310a1c"
import script from "./follow-history-query.vue?vue&type=script&lang=ts"
export * from "./follow-history-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports